/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import type School from '@linc-technologies/linced-common/models/school';
import moment from 'moment';

// Proto: dates.Term.
export default class Term extends Model {
  declare [Type]: 'term';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @attr('number')
  declare year: number | undefined;

  @attr('string', { defaultValue: '' })
  declare academicYear: string;

  @attr('number', { defaultValue: 0 })
  declare term: number;

  @attr('string')
  declare start: string | undefined;

  @attr('string')
  declare end: string | undefined;

  @belongsTo('term', { async: true, inverse: 'next' })
  declare previous: AsyncBelongsTo<Term>;

  @belongsTo('term', { async: true, inverse: 'previous' })
  declare next: AsyncBelongsTo<Term>;

  @computed('start', 'end')
  get isCurrent() {
    return this.isCurrentAtDate();
  }

  isCurrentAtDate(reportDate?: moment.MomentInput) {
    const now = moment(reportDate);
    return (
      now.isSameOrAfter(moment(this.start), 'day') &&
      now.isSameOrBefore(moment(this.end), 'day')
    );
  }

  @computed('start', 'end')
  get currencyClass() {
    const now = moment();
    const start = moment(this.start);
    const end = moment(this.end);
    let currencyClass = 'future-term';

    if (now.isSameOrAfter(start, 'day') && now.isSameOrBefore(end, 'day')) {
      currencyClass = 'current-term';
    } else if (now.isAfter(end, 'day')) {
      currencyClass = 'previous-term';
    }

    return currencyClass;
  }
}
